<template>
  <div class="outLinkBox">
    <div
      class="outLinkItem"
      v-for="(e, index) in outLinkList"
      :key="index"
      @click="outLink(e)"
    >
      <div class="img">
        <img
          :src="e.srcUrl"
          :alt="e.name"
        />
      </div>
      <p class="text">{{ e.name }}</p>
    </div>
  </div>
</template>
<script>
import xinshouzhiyin from '@/assets/images/xinshouzhiyin.png';
import chakanedu from '@/assets/images/chakanedu.png';
import huankuaishisuan from '@/assets/images/huankuaishisuan.png';
import zhinengpipei from '@/assets/images/zhinengpipei.png';

export default {
  name: 'component_name',
  data() {
    return {
      outLinkList: [
        {
          name: '新手指引',
          srcUrl: xinshouzhiyin,
          linkUrl: '/supermarket/v2/newPeople',
        },
        {
          name: '查看额度',
          srcUrl: chakanedu,
          linkUrl: '/supermarket/v2/checkAmount',
        },
        {
          name: '智能匹配',
          srcUrl: zhinengpipei,
          linkUrl: '/supermarket/v2/intelligentMatching',
        },
        {
          name: '还款试算',
          srcUrl: huankuaishisuan,
          linkUrl: '/supermarket/v2/reimbursementMiscalculation',
        },
      ],
    };
  },
  methods: {
    outLink(item) {
      if (item.name !== '查看额度') {
        this.$router.push(item.linkUrl);
      }
      if (item.name === '查看额度') {
        this.$api.LoanSupermarket.loanTestAmount().then((res) => {
          if (res.success) {
            window.location.href = res.data;
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.outLinkBox {
  box-sizing: border-box;
  height: 80px;
  padding: 13px 15px;
}
.outLinkItem {
  display: inline-block;
  height: 56px;
  box-sizing: border-box !important;
  width: 23%;
  margin-right: 2%;
  background-color: #fff;
}
.outLinkItem:last-child {
  margin-right: 0px;
}
.outLinkItem img {
  width: 24px;
  height: 24px;
  margin-top: 5px;
}
.outLinkItem .text {
  font-size: 12px;
  color: #54555c;
  font-weight: 500;
  margin: 0;
}
</style>
